module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/IM-5e86acfab31d5da21b028ce0b59c4c1b.png";